'use client';

import dompurify from 'dompurify';

interface SanitizedHTMLProps {
  html: string;
  className?: string;
}

export function SanitizedHTML({ html, className }: SanitizedHTMLProps) {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: dompurify.sanitize(html) }}
    />
  );
}
